import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { COOKIE, getCookie } from '../services/Cookie';
// Utility function to get the user role from your authentication context or state
const getUserRole = () => {
	let user = {
		userId:getCookie(COOKIE.UserId),
		token:getCookie(COOKIE.Token),
		role:getCookie(COOKIE.UserType),
	}
	return user;
};
// Component to protect admin routes
export const AdminRoute = () => {
	const userRole = getUserRole();
	const location = useLocation();
	if(userRole?.userId&&userRole?.token){
		if (userRole?.role === '0'){
			return <Navigate to="/home" state={{ from: location }} replace />;
		}
		return <Outlet />;
	}
	return <Navigate to="/admin-login" state={{ from: location }} replace />;
};
// Component to protect routes for students (e.g., prevent access to admin routes)
export const StudentRoute = () => {
	const userRole = getUserRole();
	const location = useLocation();
	if(userRole?.userId&&userRole?.token){
		if (userRole?.role !== '0'){
			return <Navigate to="/admin-dashboard" state={{ from: location }} replace />;
		}
		return <Outlet />;
	}
	return <Navigate to="/login" state={{ from: location }} replace />;
};
// Component to protect routes for types of admin users based on role
export const RoleProtectedRoute = ({allowedRoles, children }) => {
	const userRole = getUserRole();
	if (allowedRoles.includes(userRole?.role)){
		return children ? children : <Outlet/>;
	} else {
		return <Navigate to="/page-not-found" state={{ fromLocation:"fromRoutes" }} />;
	}
};
